import { useStorageValue } from "../useStorageValue/useStorageValue.js";
import { isBrowser } from "../util/const.js";
/**
 * Manages a single sessionStorage key.
 *
 * @param key Storage key to manage
 * @param defaultValue Default value to yield in case the key is not in storage
 * @param options
 */

export function useSessionStorageValue(key, defaultValue, options) {
  if (defaultValue === void 0) {
    defaultValue = null;
  }

  if (options === void 0) {
    options = {};
  }

  return useStorageValue(isBrowser ? sessionStorage : {}, key, defaultValue, options);
}